module.exports = "/static/media/glyphicons-halflings-regular.f7214668.svg";